import { getToken, getUser } from "../../Utilities/Common";
import { getWithParamsAPICall } from "../axiosMethodCall";

export const getDailyLogsReport = async (params) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "reports/professional_fee",
      {
        requester: getUser(),
        token: getToken(),
        ...params,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getCensusOfDiseases = async (params) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "reports/census_of_diseases",
      {
        requester: getUser(),
        token: getToken(),
        ...params,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
export const getSingleCensusOfDisease = async (params) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "reports/census_of_disease",
      {
        requester: getUser(),
        token: getToken(),
        ...params,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getMedicalHistorySummary = async (patient_id) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "reports/medical_history_summary",
      {
        requester: getUser(),
        token: getToken(),
        patient_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getSocialPersonalHistorySummary = async (patient_id) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "reports/social_history_summary",
      {
        requester: getUser(),
        token: getToken(),
        patient_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getResidentsReport = async (params) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "reports/resident_fees",
      {
        requester: getUser(),
        token: getToken(),
        ...params,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getOutpatientVisits = async () => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "outpatients/get_visits",
      {
        requester: getUser(),
        token: getToken(),
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
